/* eslint-disable class-methods-use-this */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import fscreen from 'fscreen';

class FullScreen extends Component {
	constructor(props) {
		super(props);

		this.detectFullScreen = this.detectFullScreen.bind(this);
		this.enterFullScreen = this.enterFullScreen.bind(this);
	}

	componentDidMount() {
		fscreen.addEventListener('fullscreenchange', this.detectFullScreen);
	}

	componentWillReceiveProps(nextProps) {
		this.handleProps(nextProps);
	}

	componentWillUnmount() {
		fscreen.removeEventListener('fullscreenchange', this.detectFullScreen);
	}

	render() {
		return (
			<div
				ref={node => (this.node = node)}
				style={
					this.props.enabled ? {
						display: 'flex',
						flexFlow: 'column',
						alignItems: 'center',
						height: '100%',
						width: '100%',
						overflowY: 'scroll'
					} : {
					}
				}
			>
				{this.props.children}
			</div>
		);
	}

	detectFullScreen() {
		if (this.props.onChange) {
			this.props.onChange(!!fscreen.fullscreenElement);
		}
	}

	enterFullScreen() {
		if (fscreen.fullscreenEnabled) {
			fscreen.requestFullscreen(this.node);
		}
	}

	leaveFullScreen() {
		if (fscreen.fullscreenEnabled) {
			fscreen.exitFullscreen();
		}
	}

	handleProps(props) {
		const enabled = fscreen.fullscreenElement;

		if (enabled && !props.enabled) {
			this.leaveFullScreen();
		} else if (!enabled && props.enabled) {
			this.enterFullScreen();
		}
	}
}

FullScreen.propTypes = {
	children: PropTypes.node.isRequired,
	enabled: PropTypes.bool,
	onChange: PropTypes.func
};

FullScreen.defaultProps = {
	enabled: false
};

export default FullScreen;



// WEBPACK FOOTER //
// ./src/client/components/common/fullscreen/index.jsx